import axios from 'axios'
import urls from './urls'

/**
 * upload image to server and return imageUrl
 * @param {String} image encoded base64 Image string
 */
const uploadImage = async function (base64Image) {
  try {
    let data = {
      encodedImage: base64Image
    }
    let res = await axios.post(urls.uploadImage, data)
    return res.data
  } catch (error) {
    console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

export {
  uploadImage
}
